// Check to see if the tab area is wider than visible width, if so show arrow
const checkStepsForOverflow = function (element) {
  const tabsSection = element.querySelector('.s-step-by-step__nav-content');
  const tabsSectionArrow = element.querySelector('.s-step-by-step__arrow');

  if (tabsSection.scrollWidth > tabsSection.offsetWidth + 15) {
    tabsSectionArrow.classList.add('s-step-by-step__arrow--visible');
  } else {
    tabsSectionArrow.classList.remove('s-step-by-step__arrow--visible');
  }
};

const stepByStepInit = (element) => {
  if (element) {
    const id = element.getAttribute('data-id');
    
    if (!id) return;

    const steps = new Tabby(`[data-id="${id}"] [data-step-by-step]`);
    checkStepsForOverflow(element);
  
    const prevNextButtons = element.querySelectorAll('.s-step-by-step__prev-next a');
    prevNextButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        steps.toggle(event.target.hash);
        event.preventDefault();
      });
    });
  
    // window resize
    window.onresize = function (event) {
      delay(function () {
        checkStepsForOverflow(element);
      }, 500);
    };
  
    new ScrollBooster({
      viewport: element.querySelector('.s-step-by-step__nav'),
      content: element.querySelector('.s-step-by-step__nav-content'),
      scrollMode: 'native',
      direction: 'horizontal',
      bounce: false,
      pointerMode: 'mouse'
    });
  }
}


const stepByStep = document.querySelectorAll('.s-step-by-step');
stepByStep.forEach(step => stepByStepInit(step));
